export default "__VITE_PUBLIC_ASSET__93ddfbf0__"